import { FunctionComponent } from 'react';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spinner from '../../UI/V3/Spinner';
import Button from '../../UI/V3/Button/Button';
import styles from './DuplicateLocationModal.module.scss';

interface DuplicateLocationProgressProps {
    locationName: string;
    // The status stopped being checked before the duplication finished
    stalled: boolean;
    onClose: () => void;
}

export const DuplicateLocationProgress: FunctionComponent<DuplicateLocationProgressProps> = ({
    locationName,
    stalled,
    onClose
}) => {
    if (stalled) {
        return (
            <div className={styles.statusScreen}>
                <FontAwesomeIcon
                    icon={faClock}
                    className={styles.statusIcon}
                />
                <span className={styles.statusTitle}>Still duplicating {locationName}</span>
                <p className={styles.statusMessage}>
                    This is taking longer than usual. The new location will appear in the locations list when it&apos;s
                    ready.
                </p>
                <Button
                    label="Close"
                    variant="black"
                    size="large"
                    onClick={onClose}
                />
            </div>
        );
    }

    return (
        <div className={styles.statusScreen}>
            <Spinner />
            <span className={styles.statusTitle}>Duplicating {locationName}…</span>
            <p className={styles.statusMessage}>
                This can take a few minutes. You can close this window, the duplication will keep running and the new
                location will appear in the locations list when it&apos;s ready.
            </p>
        </div>
    );
};

export default DuplicateLocationProgress;
